import dayjs from "dayjs";

import EmailIcon from "@assets/icons/email.svg";

import { IThreadTag } from "@interfaces/tag.interface";
import { useTimezones } from "@hooks/useTimezones";
import formatDateAgo from "@utils/date.util";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IThreadTag;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionThread = ({ item, ...rest }: Props) => {
  const { userTimezoneOffset } = useTimezones();

  const formattedDate = formatDateAgo(dayjs(item.sent_date).toISOString(), userTimezoneOffset);

  return (
    <div
      {...rest}
      className="flex min-w-0 cursor-pointer items-center justify-between gap-2 p-2"
    >
      <div className="flex items-center gap-2 flex-1 overflow-hidden">
        <EmailIcon
          width={20}
          height={20}
          className="flex-shrink-0 text-[#6B7080] dark:text-gray-400"
        />
        <TagLabel>{item.subject?.trim() || "(No subject)"}</TagLabel>
      </div>

      <div className="text-xs text-gray-450">{formattedDate}</div>
    </div>
  );
};
